import * as Blockly from 'blockly/core';

export function registerNumberPreset(workspace: Blockly.WorkspaceSvg): void {
    const varMap = workspace.getVariableMap();
    if (!varMap.getVariable('i', 'float')) {
        varMap.createVariable('i', 'float');
    }
    if (!varMap.getVariable('lat', 'float')) {
        varMap.createVariable('lat', 'float');
    }
    if (!varMap.getVariable('lng', 'float')) {
        varMap.createVariable('lng', 'float');
    }
}
